import {
  base_colorContentBorder,
  base_colorSurfaceMuted,
  base_contentHover,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const container = css`
  position: relative;
`

export const popover = css`
  position: absolute;
  top: calc(100% + ${spacing(2)});
  right: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: ${spacing(2)};
  min-width: 200px;
  padding: ${spacing(3)};
  background-color: white;
  border: 1px solid ${base_colorContentBorder};
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
`

export const option = css`
  display: flex;
  align-items: center;
  gap: ${spacing(2)};
  ${font_md};
  cursor: pointer;
  padding: ${spacing(1)} ${spacing(2)};
  border-radius: 4px;

  &:hover {
    background-color: ${base_contentHover};
  }
`

export const countBadge = css`
  margin-left: ${spacing(2)};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 ${spacing(1)};
  border-radius: 9px;
  background-color: ${base_colorSurfaceMuted};
  ${font_md};
`
